var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10V3c0-.55.45-1 1-1h10.59c.26 0 .52.11.7.29l3.42 3.42c.18.18.29.44.29.7V21c0 .5-.5 1-1 1H7c-.55 0-1-.45-1-1v-2M9 6h5",
    stroke: "#35b9bf",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2v5h5v-.59c0-.26-.11-.52-.29-.7l-3.42-3.42c-.18-.18-.44-.29-.7-.29H17z",
    stroke: "#35b9bf",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11a1 1 0 011-1h15a1 1 0 011 1v7a1 1 0 01-1 1H3a1 1 0 01-1-1v-7z",
    stroke: "#35b9bf",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.662 16.5h1.13v-1.165h.566c1.008 0 1.748-.507 1.748-1.474v-.012c0-.903-.665-1.427-1.69-1.427H4.662V16.5zm1.13-2.05v-1.08h.537c.402 0 .652.18.652.53v.012c0 .326-.25.536-.647.536h-.541zM8.7 16.5h1.555c1.462 0 2.319-.868 2.319-2.05v-.012c0-1.183-.845-2.016-2.296-2.016H8.699V16.5zm1.59-3.082c.681 0 1.13.379 1.13 1.037v.012c0 .658-.449 1.03-1.13 1.03h-.46v-2.08h.46zm2.986 3.082h1.13v-1.457h1.93v-.938h-1.93v-.693h2.133v-.99h-3.263V16.5z",
    fill: "#35b9bf"
  })));
}

export default SvgPdf;